import type { SignupApi } from '../services/signup-api/signup-api';
import type { WrapUpContext } from './branching';

/**
 * For a sponsor that offers Spanish, record the language the member signed up
 * in as their call language, as the legacy signup did. Started, never awaited,
 * and best effort like the interpreter question's own save: a refused save
 * already shows in the API's request logs, and the member never sees it. The
 * server never lets this replace a language the member picked, so its order
 * against the interpreter question does not matter.
 */
export function recordAppLanguageDefault(
  api: SignupApi,
  context: WrapUpContext,
  uiLanguage: string,
): void {
  if (!context.spanish) return;
  const language = uiLanguage.toLowerCase().startsWith('es') ? 'es' : 'en';
  api.saveAppLanguageDefault({ language }).catch(() => undefined);
}
